import styled from 'styled-components'

export const Container = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.visitorParkingBg,
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  maxHeight: '100vh',
  minHeight: '100vh',
  width: '100%',
}))

export const ScrollContainer = styled.div({
  height: '100%',
  overflowY: 'auto',
  width: '100%',
})

export const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '1.6rem',
  height: '100%',
  margin: '0 auto',
  maxWidth: '40rem',
  padding: '3rem 2.4rem',
  width: '100%',
})

export const BottomSpace = styled.div({
  flexShrink: 0,
  height: '1.4rem',
})

export const Footer = styled.footer(({ theme }) => ({
  alignItems: 'center',
  backgroundColor: theme.colors.white,
  boxShadow: theme.shadow.xl,
  display: 'flex',
  gap: theme.space['8'],
  justifyContent: 'space-between',
  padding: theme.space['20'],
  width: '100%',
  zIndex: theme.zIndex.level1,
}))
